import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { storage } from '../utils/storage';

const CTASection: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handlePostVehicle = () => {
    const token = storage.getAuthToken();
    if (token) {
      navigate('/dashboard/create-listing');
    } else {
      navigate('/login?redirect=/dashboard/create-listing');
    }
  };

  return (
    <section className="hp-cta-section">
      <div className="hp-container">
        <h2 className="mb-4">{t('home.cta_title')}</h2>
        <p className="mb-5" style={{ maxWidth: '600px', margin: '0 auto' }}>
          {t('home.cta_subtitle')}
        </p>
        <button className="btn-hp-primary" onClick={handlePostVehicle}>
          {t('home.cta_button')}
        </button>
      </div>
    </section>
  );
};

export default CTASection;
